import { useEffect } from 'react'

// These helpers copy the query result instead of assigning into it: the result
// object belongs to Apollo Client and mutating it relies on the library never
// freezing or reusing it.

export function cacheSafeSkeleton(queryResult: any, skeletonData: any) {
  if (!queryResult?.data && (queryResult?.loading || testingSkeleton())) {
    return { ...queryResult, data: skeletonData }
  }
  return queryResult
}

export function applySkeleton(queryResult: any, skeletonData: any, skipSkeleton = false) {
  if (!skipSkeleton && (queryResult.loading || testingSkeleton())) {
    return { ...queryResult, data: skeletonData }
  }
  return queryResult
}

export function testingSkeleton() {
  if (typeof window === 'undefined') return null
  if (typeof window.localStorage === 'undefined') return null
  return window.localStorage.testSkeleton
}

// To use with `useLazyQuery` whenever the query should only be performed
// when another skeleton data has alreday been loaded
// This is useful for example when we need to load data based on a fund id
// and we need the fund id to be present, and not empty data
// `variables` are passed here rather than to `useLazyQuery`: Apollo Client 4
// accepts them only on the execute function.
export function useLazySkeleton(condition: any, lazyQueryResult: any, skeletonData: any, variables?: any) {
  const [performQuery, result] = lazyQueryResult

  // Call sites pass `variables` as an inline literal, so the effect depends on
  // its serialized value: a referentially-fresh-but-equal object must not
  // re-fire the query.
  const variablesJson = variables ? JSON.stringify(variables) : undefined

  useEffect(() => {
    if (!condition)
      performQuery(variablesJson ? { variables: JSON.parse(variablesJson) } : undefined)
  }, [condition, performQuery, variablesJson])

  const seeded = result.data ? result : { ...result, data: skeletonData }
  return applySkeleton(seeded, skeletonData)
}
